export default {
    "NavaTel": "NavaTel",
    "Logout": "Logout",
    "Dashboard": "Dashboard",
    "Users settings": "Users settings",
    "Definition of operator": "Definition of operator",
    "List of users": "List of users",
    "Role management": "Role management",
    "Messages to operators": "Messages to operators",
    "Opps!!!": "Opps!!!",
    "This page you are looking for could not be found": "This page you are looking for could not be found",
    "Go Back to Home":  "Go Back to Home",
    "Settings":  "Settings",
    "Theme Color":  "Theme Color",
    "Theme Dark Color":  "Theme Dark Color",
    "Home":  "Home",
    "User Profile": "User Profile",
    "My Profile":  "My Profile",
    "Account settings":  "Account settings",
    "My Inbox":  "My Inbox",
    "Messages & Emails":  "Messages & Emails",
    "My Tasks":  "My Tasks",
    "To-do and Daily tasks":  "To-do and Daily tasks",
    "Notifications": "Notifications",
    "See all Notifications": "See all Notifications",

    "":  ""
}
